















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {State} from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {i18nAllObject} from '@/utils/i18n';
import {changeDateFormat} from '@/utils/dateUtils';
import {writeExcel} from '@/utils/excel';

@Component({
  components: {CompSelectBox}
})
export default class ItemTable extends Vue {
  @Prop() private option?: any;
  private initOver = false;
  private itemInfo = {
    haveRigthBtn: true,
    haveConfigBtn: true,
    havePageSizeBtn: true,
    haveExcelDownBtn: true,
    noBorder: false,
    onLoadSearch: false,
    excelDownInfo: null as any,
    pageSize: '30',
    pageSizes: [
      {
        value: '30',
        name: 'COMMON_PAGE_SIZE_30'
      },
      {
        value: '50',
        name: 'COMMON_PAGE_SIZE_50'
      },
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      }
    ]
  };

  @Prop({required: true})
  private gridProps!: any;
  @Prop({required: true})
  private data!: [];
  @Prop({default: 0})
  private totalCount!: number;
  @Prop({default: 0})
  private bodyheight!: number;

  @State private onGnb!: boolean;
  @Watch('onGnb')
  onGnbChanged() {
    if (this.$refs.tuiGrid!=null && this.$refs.tuiGrid!=undefined)
    (this.$refs.tuiGrid as Grid).invoke('refreshLayout');
  }

  private changePageSize(value: any) {
    this.$emit('resetData', 1, Number(value));
  }

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination') as any;
    if (this.bodyheight > 0){
      grid.invoke('setBodyHeight', this.bodyheight);
    } else {
      grid.invoke('setBodyHeight', this.data.length === 0 ? 190 : 480);
    }

    if (pagination) {
      const pageState = {
        totalCount: this.totalCount,
        page: this.gridProps.options.pageOptions.page,
        perPage: this.gridProps.options.pageOptions.perPage
      };
      grid.invoke('resetData', this.data as any, {pageState});
    } else {
      grid.invoke('resetData', this.data as any);
    }
    this.$nextTick(() => {
      grid.invoke('refreshLayout');
    });
  }

  private excelDown() {
    if (this.data && this.data.length > 0) {
      let columns = i18nAllObject(this, this.itemInfo.excelDownInfo.columns);
      let fileName = this.itemInfo.excelDownInfo.fileName;
      if (this.itemInfo.excelDownInfo.nameDateFormat !== undefined) {
        fileName += changeDateFormat(new Date(), this.itemInfo.excelDownInfo.nameDateFormat);
      }
      writeExcel(this.data, columns, fileName, this.itemInfo.excelDownInfo.formatters);
    } else {
      alert(this.$t('COMMON_NOT_DATA'));
    }
  }

  private getCheckedRowKeys() {
    return (this.$refs.tuiGrid as Grid).invoke('getCheckedRowKeys');
  }

  private getCheckedItems(propName: string) {
    const grid = this.$refs.tuiGrid as Grid;
    const items = grid.invoke('getCheckedRows').map(item => item[propName]);
    return items.join(',');
  }

  private initOption() {
    if (this.option) {
      if (this.option.haveRigthBtn !== undefined) {
        this.itemInfo.haveRigthBtn = this.option.haveRigthBtn;
      }
      if (this.option.haveConfigBtn !== undefined) {
        this.itemInfo.haveConfigBtn = this.option.haveConfigBtn;
      }
      if (this.option.havePageSizeBtn !== undefined) {
        this.itemInfo.havePageSizeBtn = this.option.havePageSizeBtn;
      }
      if (this.option.haveExcelDownBtn !== undefined) {
        this.itemInfo.haveExcelDownBtn = this.option.haveExcelDownBtn;
      }
      if (this.option.noBorder !== undefined) {
        this.itemInfo.noBorder = this.option.noBorder;
      }
      if (this.option.onLoadSearch !== undefined) {
        this.itemInfo.onLoadSearch = this.option.onLoadSearch;
      }
      if (this.option.excelDownInfo !== undefined) {
        this.itemInfo.excelDownInfo = this.option.excelDownInfo;
      }
      if (this.option.pageSize !== undefined) {
        this.itemInfo.pageSize = this.option.pageSize;
      }
      if (this.option.pageSizes !== undefined) {
        this.itemInfo.pageSizes = this.option.pageSizes;
      }
    }
    this.initOver = true;
  }

  private async mounted() {
    await this.initOption();
    const grid = this.$refs.tuiGrid as Grid;
    if (this.bodyheight){
      grid.invoke('setBodyHeight', this.bodyheight);
    }

    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.$emit('resetData', ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });

    if (this.itemInfo.onLoadSearch) {
      this.$emit('resetData', 1);
    }
  }
}
